import { Box } from '@mui/material';
import { keyframes } from '@mui/system';
import React from 'react';

export default function AppLoader() {
  const loaderStyle = {
    width: 75,
    height: 75,
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 'auto',
  };
  const cubeStyle = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    borderRadius: 2,
  };
  const glowingStyle = {
    zIndex: 2,
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    border: '2px solid rgba(255, 255, 255, 0.3)',
  };
  const loadtwoStyle = keyframes`
    0% { transform: rotate(0deg); }
    50% { transform: rotate(-80deg); }
    100% { transform: rotate(0deg); }
  `;
  const colorStyle = {
    zIndex: 1,
    filter: 'blur(2px)',
    background: 'linear-gradient(135deg, #1afbf0, #da00ff)',
    animation: `${loadtwoStyle} 2.5s ease-in-out infinite`,
  };

  return (
    <Box sx={loaderStyle}>
      <Box sx={{ ...cubeStyle, ...glowingStyle }} />
      <Box sx={{ ...cubeStyle, ...colorStyle }} />
    </Box>
  );
}
